import React from "react";

function CouponFlash({ item }) {
  if (!item) return null;

  return (
    <div className="coupon-banner">
      <div className="coupon-left">
        <h3>
          {item.discountType === "PERCENTAGE"
            ? `EXTRA ${item.discountValue}% OFF`
            : `FLAT ₹${item.discountValue} OFF`}
        </h3>

        <p>{item.title}</p>
      </div>

      <div className="coupon-divider" />

      <div className="coupon-right">
        <h4>Use Coupon</h4>

        <div className="coupon-code-box">
          {item.code}
        </div>
      </div>
    </div>
  );
}

export default CouponFlash;